import { render, staticRenderFns } from "./CommonViewForm.vue?vue&type=template&id=3a5dfc90&scoped=true"
import script from "./CommonViewForm.vue?vue&type=script&lang=js"
export * from "./CommonViewForm.vue?vue&type=script&lang=js"
import style0 from "./CommonViewForm.vue?vue&type=style&index=0&id=3a5dfc90&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5dfc90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5dfc90')) {
      api.createRecord('3a5dfc90', component.options)
    } else {
      api.reload('3a5dfc90', component.options)
    }
    module.hot.accept("./CommonViewForm.vue?vue&type=template&id=3a5dfc90&scoped=true", function () {
      api.rerender('3a5dfc90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/components/CommonViewForm.vue"
export default component.exports